import { useQuery } from "@tanstack/react-query";
import * as userApi from "./api";
import type { UsersFilterParams } from "./types";

export function useUsers(params: UsersFilterParams = {}) {
  return useQuery({
    queryKey: ["users", params],
    queryFn: () => userApi.fetchUsers(params),
    placeholderData: (previous) => previous,
  });
}

export function useUser(id?: number) {
  return useQuery({
    queryKey: ["users", "detail", id],
    queryFn: () => userApi.fetchUserById(id as number),
    enabled: Number.isFinite(id) && Number(id) > 0,
  });
}

export function useUserDepartmentOptions() {
  return useQuery({
    queryKey: ["users", "departments", "options"],
    queryFn: userApi.fetchDepartmentOptions,
    staleTime: 5 * 60 * 1000,
  });
}